import React, { createContext, useState } from 'react';

export const CopyContext = createContext();

const CopyProvider = ({ children }) => {
    const [copyFlg, setCopyFlg] = useState(false);

    return (
        <CopyContext.Provider value={{ copyFlg, setCopyFlg }}>
            {children}
        </CopyContext.Provider>
    );
}

export { CopyProvider };
